import { render, staticRenderFns } from "./MenuConfiguration.vue?vue&type=template&id=4b7fa17a&"
import script from "./MenuConfiguration.vue?vue&type=script&lang=js&"
export * from "./MenuConfiguration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports